import React from 'react';
import SingleCode from './SingleCode';
import {inject, observer} from 'mobx-react';


@inject('webinarCreate')
@observer
export default class AddDiscountCode extends React.Component {

  addEmptyCoupon = e => {
    e.preventDefault();
    this.props.webinarCreate.addEmptyCoupon()
  };

  canAddNewCoupon(){
    return this.props.webinarCreate.workshop.coupons_attributes.filter(el => !el._destroy).length < 3
  }

  render(){
    return (
      <div className="row" style={{display: 'grid'}}>
        {this.props.webinarCreate.workshop.coupons_attributes.map(el => <SingleCode el={el}
                                                                                     key={el.id}/>)}
        {this.canAddNewCoupon() &&
        <a href="#"
           className="add-discount offset-5 col-3"
           onClick={this.addEmptyCoupon}
           >Add Discount Code</a>}
      </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/components/create_webinar/AddDiscountCode.jsx